import React, { useState } from 'react';
import { ServerIcon, CheckCircleIcon, XCircleIcon, ArrowUpCircleIcon, KeyIcon, PlusCircleIcon, SaveIcon, XIcon, ToggleLeftIcon, ToggleRightIcon, BotIcon } from 'lucide-react';
import { mockModelData } from '../utils/mockData';
const ModelCard = ({
  model,
  onLoad,
  onUnload
}) => {
  return <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 flex flex-col h-full" data-id="element-324">
      <div className="flex justify-between items-start mb-2" data-id="element-325">
        <div data-id="element-326">
          <h3 className="text-base font-medium text-gray-900" data-id="element-327">{model.name}</h3>
          <p className="text-xs text-gray-500" data-id="element-328">{model.description}</p>
        </div>
        <div className={`px-2 py-0.5 rounded-full text-xs font-medium ${model.status === 'loaded' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-329">
          {model.status === 'loaded' ? 'Loaded' : 'Available'}
        </div>
      </div>
      <div className="mt-2 grid grid-cols-2 gap-x-4 gap-y-1 text-xs text-gray-500" data-id="element-330">
        <div data-id="element-331">
          <span className="font-medium" data-id="element-332">Size:</span> {model.size}
        </div>
        <div data-id="element-333">
          <span className="font-medium" data-id="element-334">Version:</span> {model.version}
        </div>
        <div data-id="element-335">
          <span className="font-medium" data-id="element-336">Family:</span> {model.family}
        </div>
        <div data-id="element-337">
          <span className="font-medium" data-id="element-338">Context:</span> {model.context}
        </div>
      </div>
      <div className="mt-3 flex space-x-2 pt-2 border-t border-gray-100 mt-auto" data-id="element-339">
        {model.status === 'loaded' ? <button onClick={() => onUnload(model.id)} className="flex items-center px-3 py-1 border border-red-300 text-red-600 rounded-md hover:bg-red-50 transition-colors text-xs" data-id="element-340">
            <XCircleIcon size={14} className="mr-1" data-id="element-341" />
            Unload
          </button> : <button onClick={() => onLoad(model.id)} className="flex items-center px-3 py-1 border border-blue-300 text-blue-600 rounded-md hover:bg-blue-50 transition-colors text-xs" data-id="element-342">
            <CheckCircleIcon size={14} className="mr-1" data-id="element-343" />
            Load
          </button>}
        {model.hasUpdate && <button className="flex items-center px-3 py-1 border border-purple-300 text-purple-600 rounded-md hover:bg-purple-50 transition-colors text-xs" data-id="element-344">
            <ArrowUpCircleIcon size={14} className="mr-1" data-id="element-345" />
            Upgrade
          </button>}
      </div>
    </div>;
};
const SaasModelCard = ({
  provider,
  onDelete,
  onToggleModel
}) => {
  const [apiKey, setApiKey] = useState(provider.apiKey || '');
  const [isConnected, setIsConnected] = useState(provider.isConnected || false);
  const handleConnect = () => {
    if (apiKey.trim()) {
      setIsConnected(true);
    }
  };
  const handleDisconnect = () => {
    setApiKey('');
    setIsConnected(false);
  };
  return <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200" data-id="element-346">
      <div className="flex justify-between items-start" data-id="element-347">
        <div data-id="element-348">
          <h3 className="text-base font-medium text-gray-900" data-id="element-349">
            {provider.name}
          </h3>
          <p className="text-xs text-gray-500" data-id="element-350">{provider.description}</p>
        </div>
        <div className="flex items-center space-x-2" data-id="element-351">
          <div className={`px-2 py-0.5 rounded-full text-xs font-medium ${isConnected ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-352">
            {isConnected ? 'Connected' : 'Not Connected'}
          </div>
          {onDelete && <button onClick={() => onDelete(provider.id)} className="text-gray-400 hover:text-red-500" title="Remove provider" data-id="element-353">
              <XIcon size={14} data-id="element-354" />
            </button>}
        </div>
      </div>
      <div className="mt-3" data-id="element-355">
        <div className="flex items-center mb-1" data-id="element-356">
          <KeyIcon size={14} className="mr-1 text-gray-400" data-id="element-357" />
          <span className="text-xs font-medium text-gray-700" data-id="element-358">API Key</span>
        </div>
        <div className="flex space-x-2" data-id="element-359">
          <input type={isConnected ? 'password' : 'text'} value={isConnected ? '••••••••••••••••••••••' : apiKey} onChange={e => !isConnected && setApiKey(e.target.value)} disabled={isConnected} placeholder="Enter API key" className="flex-1 px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-xs" data-id="element-360" />
          {isConnected ? <button onClick={handleDisconnect} className="px-2 py-1 border border-red-300 text-red-600 rounded-md hover:bg-red-50 transition-colors text-xs" data-id="element-361">
              Disconnect
            </button> : <button onClick={handleConnect} disabled={!apiKey.trim()} className={`px-2 py-1 rounded-md transition-colors text-xs ${apiKey.trim() ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-200 text-gray-500 cursor-not-allowed'}`} data-id="element-362">
              Connect
            </button>}
        </div>
      </div>
      {isConnected && <div className="mt-3 border-t border-gray-200 pt-2" data-id="element-363">
          <h4 className="text-xs font-medium text-gray-700 mb-1 flex justify-between items-center" data-id="element-364">
            <span data-id="element-365">Available Models</span>
            <span className="text-xs text-gray-500" data-id="element-366">
              Toggle to enable/disable
            </span>
          </h4>
          <div className="space-y-1" data-id="element-367">
            {provider.models.map((model, index) => <div key={index} className="flex justify-between items-center p-1.5 bg-gray-50 rounded" data-id="element-368">
                <div data-id="element-369">
                  <span className="text-xs font-medium" data-id="element-370">{model.name}</span>
                  <span className="text-xs text-gray-500 ml-1" data-id="element-371">
                    {model.version}
                  </span>
                </div>
                <button onClick={() => onToggleModel(provider.id, index)} className={`${model.enabled ? 'text-green-600' : 'text-gray-400'} hover:text-green-700`} title={model.enabled ? 'Disable model' : 'Enable model'} data-id="element-372">
                  {model.enabled ? <ToggleRightIcon size={16} data-id="element-373" /> : <ToggleLeftIcon size={16} data-id="element-374" />}
                </button>
              </div>)}
          </div>
        </div>}
    </div>;
};
const AddSaasProviderForm = ({
  onAdd,
  onCancel
}) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [models, setModels] = useState([{
    name: '',
    version: '',
    enabled: true
  }]);
  const handleAddModel = () => {
    setModels([...models, {
      name: '',
      version: '',
      enabled: true
    }]);
  };
  const handleModelChange = (index, field, value) => {
    const updatedModels = [...models];
    updatedModels[index][field] = value;
    setModels(updatedModels);
  };
  const handleRemoveModel = index => {
    setModels(models.filter((_, i) => i !== index));
  };
  const handleSubmit = () => {
    // Filter out empty models
    const validModels = models.filter(model => model.name.trim() !== '');
    if (name.trim() && validModels.length > 0) {
      onAdd({
        id: Date.now(),
        name,
        description,
        models: validModels,
        isConnected: false,
        apiKey: ''
      });
      // Reset form
      setName('');
      setDescription('');
      setModels([{
        name: '',
        version: '',
        enabled: true
      }]);
    }
  };
  return <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200" data-id="element-375">
      <div className="flex justify-between items-center mb-3" data-id="element-376">
        <h3 className="text-base font-medium text-gray-900" data-id="element-377">
          Add New SaaS Provider
        </h3>
        <button onClick={onCancel} className="text-gray-400 hover:text-gray-600" data-id="element-378">
          <XIcon size={16} data-id="element-379" />
        </button>
      </div>
      <div className="space-y-3" data-id="element-380">
        <div data-id="element-381">
          <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-382">
            Provider Name
          </label>
          <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="e.g., Cohere, Mistral AI" className="w-full px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-xs" data-id="element-383" />
        </div>
        <div data-id="element-384">
          <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-385">
            Description
          </label>
          <input type="text" value={description} onChange={e => setDescription(e.target.value)} placeholder="e.g., Enterprise-grade LLM provider" className="w-full px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-xs" data-id="element-386" />
        </div>
        <div data-id="element-387">
          <div className="flex justify-between items-center mb-1" data-id="element-388">
            <label className="block text-xs font-medium text-gray-700" data-id="element-389">
              Available Models
            </label>
            <button onClick={handleAddModel} className="text-xs text-blue-600 hover:text-blue-800 flex items-center" data-id="element-390">
              <PlusCircleIcon size={14} className="mr-1" data-id="element-391" />
              Add Model
            </button>
          </div>
          <div className="space-y-2" data-id="element-392">
            {models.map((model, index) => <div key={index} className="flex items-center space-x-2" data-id="element-393">
                <input type="text" value={model.name} onChange={e => handleModelChange(index, 'name', e.target.value)} placeholder="Model name" className="flex-1 px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-xs" data-id="element-394" />
                <input type="text" value={model.version} onChange={e => handleModelChange(index, 'version', e.target.value)} placeholder="Version" className="w-1/4 px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-xs" data-id="element-395" />
                <div className="flex items-center space-x-1" data-id="element-396">
                  <span className="text-xs text-gray-500" data-id="element-397">Enabled</span>
                  <input type="checkbox" checked={model.enabled} onChange={e => handleModelChange(index, 'enabled', e.target.checked)} className="h-3 w-3 text-blue-600 rounded" data-id="element-398" />
                </div>
                {models.length > 1 && <button onClick={() => handleRemoveModel(index)} className="text-gray-400 hover:text-red-500" data-id="element-399">
                    <XIcon size={14} data-id="element-400" />
                  </button>}
              </div>)}
          </div>
        </div>
        <div className="flex justify-end pt-3" data-id="element-401">
          <button onClick={onCancel} className="px-3 py-1 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors mr-2 text-xs" data-id="element-402">
            Cancel
          </button>
          <button onClick={handleSubmit} disabled={!name.trim() || !models.some(m => m.name.trim())} className={`px-3 py-1 rounded-md transition-colors flex items-center text-xs ${name.trim() && models.some(m => m.name.trim()) ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-200 text-gray-500 cursor-not-allowed'}`} data-id="element-403">
            <SaveIcon size={14} className="mr-1" data-id="element-404" />
            Add Provider
          </button>
        </div>
      </div>
    </div>;
};
const ModelManagement = () => {
  const [models, setModels] = useState(mockModelData.selfDeployed);
  const [saasProviders, setSaasProviders] = useState([{
    id: 1,
    name: 'OpenAI',
    description: 'Access to GPT models via API',
    isConnected: true,
    apiKey: 'sk_1234567890',
    models: [{
      name: 'gpt-4-turbo',
      version: 'Latest',
      enabled: true
    }, {
      name: 'gpt-4',
      version: 'v1.0',
      enabled: false
    }, {
      name: 'gpt-3.5-turbo',
      version: 'Latest',
      enabled: true
    }]
  }, {
    id: 2,
    name: 'Anthropic',
    description: 'Access to Claude models via API',
    isConnected: true,
    apiKey: 'sk_ant_9876543210',
    models: [{
      name: 'claude-3-opus',
      version: 'Latest',
      enabled: true
    }, {
      name: 'claude-3-sonnet',
      version: 'Latest',
      enabled: true
    }, {
      name: 'claude-3-haiku',
      version: 'Latest',
      enabled: false
    }]
  }]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [activeTab, setActiveTab] = useState('self-deployed');
  const handleLoadModel = modelId => {
    setModels(models.map(model => model.id === modelId ? {
      ...model,
      status: 'loaded'
    } : model));
  };
  const handleUnloadModel = modelId => {
    setModels(models.map(model => model.id === modelId ? {
      ...model,
      status: 'available'
    } : model));
  };
  const handleAddProvider = newProvider => {
    setSaasProviders([...saasProviders, newProvider]);
    setShowAddForm(false);
  };
  const handleDeleteProvider = providerId => {
    setSaasProviders(saasProviders.filter(provider => provider.id !== providerId));
  };
  const handleToggleModel = (providerId, modelIndex) => {
    setSaasProviders(saasProviders.map(provider => {
      if (provider.id === providerId) {
        const updatedModels = [...provider.models];
        updatedModels[modelIndex] = {
          ...updatedModels[modelIndex],
          enabled: !updatedModels[modelIndex].enabled
        };
        return {
          ...provider,
          models: updatedModels
        };
      }
      return provider;
    }));
  };
  return <div className="space-y-4" data-id="element-405">
      <h1 className="text-2xl font-bold text-gray-800" data-id="element-406">Model Management</h1>
      <div className="flex border-b border-gray-200" data-id="element-407">
        <button className={`py-2 px-4 font-medium text-sm focus:outline-none ${activeTab === 'self-deployed' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('self-deployed')} data-id="element-408">
          <div className="flex items-center" data-id="element-409">
            <ServerIcon size={16} className="mr-2" data-id="element-410" />
            Self Deployed Models
          </div>
        </button>
        <button className={`py-2 px-4 font-medium text-sm focus:outline-none ${activeTab === 'saas' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('saas')} data-id="element-411">
          <div className="flex items-center" data-id="element-412">
            <KeyIcon size={16} className="mr-2" data-id="element-413" />
            SaaS Models
          </div>
        </button>
      </div>
      {activeTab === 'self-deployed' && <section data-id="element-414">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-415">
            {models.map(model => <ModelCard key={model.id} model={model} onLoad={handleLoadModel} onUnload={handleUnloadModel} data-id="element-416" />)}
          </div>
        </section>}
      {activeTab === 'saas' && <section data-id="element-417">
          <div className="flex items-center justify-between mb-3" data-id="element-418">
            {!showAddForm && <button onClick={() => setShowAddForm(true)} className="flex items-center px-2 py-1 bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 transition-colors text-xs" data-id="element-419">
                <PlusCircleIcon size={14} className="mr-1" data-id="element-420" />
                Add Provider
              </button>}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-421">
            {showAddForm && <AddSaasProviderForm onAdd={handleAddProvider} onCancel={() => setShowAddForm(false)} data-id="element-422" />}
            {saasProviders.map(provider => <SaasModelCard key={provider.id} provider={provider} onDelete={handleDeleteProvider} onToggleModel={handleToggleModel} data-id="element-423" />)}
          </div>
        </section>}
    </div>;
};
export default ModelManagement;